module.exports = __webpack_public_path__ + "h5/img/wang.6e31a4a5.jpg";